<script setup lang="ts">
import { rewardReferralCode } from '~/utils/rewardRegistration'

definePageMeta({ validate: route => !!rewardReferralCode(route.params.code) })
const route = useRoute()
const localePath = useLocalePath()
await navigateTo(localePath({ path: '/auth/register', query: { referral: rewardReferralCode(route.params.code) } }), { redirectCode: 302 })
</script>

<template>
  <div />
</template>
